const filterTemplate = `
    <div class="filter-box"><div class="filter-popup"><ul></ul></div></div>
`;
const filterCollumnTemplate = `
    <span class="item_selected"></span>
    <span class="close-i"></span>
    <div class="filter-box">
        <div class="filter-popup"><input type="text" placeholder="Typing here" /><ul></ul></div>
    </div>
`;
Element.prototype.hasClass = function (className) {
	if (this.classList.contains(className)) return true;
	var parentNode = this.closest('.' + className);
	if (parentNode) return true;
	return false;
};
function isElementFullyVisible(el) {
	const rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}
document.body.addEventListener('click', function (event) {
	var targetElement = event.target;
	if (targetElement.classList.contains('box_no')) return changeRowChecked(targetElement);
	if (targetElement.classList.contains('close-i2')) return clearAllFilter(targetElement);
	if (targetElement.classList.contains('close-i')) return clearCurrentFilter(targetElement);
	if (targetElement.hasClass('filter-check')) return changeFilterCheck(targetElement);

	if (targetElement.classList.contains('next_status')) {
		var editorTag = document.querySelector('.row-focused .text_editor');
		nextStatus(editorTag);
	}
	showMenuExpress();
	var isDouble = false;
	if (targetElement.tagName === 'EDITOR') isDouble = true;

	var cell = document.querySelector('editor');
	if (cell) {
		if (!isDouble) {
			var dataClassEditor = cell.parentElement.getAttribute('data-class');
			if (dataClassEditor) cell.parentElement.className = dataClassEditor;
		}
		cell.parentElement.innerHTML = cell.innerText;
	}


	var ulActive = document.querySelector('.text_editor ul:has(li)');

	if (isDouble && !ulActive) {
		var textValue = targetElement.innerText.trim();
		var processingElement = document.querySelector('.editor-processing');
		processingElement.innerHTML = targetElement.innerText + '<input value="' + textValue + '" onfocus="this.selectionStart = this.value.length" />';
		addFilterTemplate(processingElement);
		processingElement.querySelector('input').focus();
		var inputTag = processingElement.querySelector('input');
		inputTag.setAttribute('data-old', textValue);
		inputTag.focus();
		inputTag.dispatchEvent(new Event('input', { bubbles: true }));
	}

	if (targetElement.classList.contains('text_editor')) {
		var previousElement = document.querySelector('.editor-processing');
		if (previousElement) previousElement.classList.remove('editor-processing');
		var dataClass = targetElement.getAttribute('data-class');
		if (!dataClass) targetElement.setAttribute('data-class', targetElement.className);
		targetElement.className = 'text_editor editor-processing';
		//targetElement.classList.add('editor-processing')
		targetElement.innerHTML = '<span class="opacity-0">' + targetElement.innerText + '</span>' + '<editor> ' + targetElement.innerText + '</editor>';
	};

	addNewRow();

	var typingElement = targetElement.closest('.filter-typing');
	if (!typingElement) {
		closeFilterTyping();
	} else {
		if (targetElement.tagName === 'LI') {
			updateLiSelected(targetElement);
		}
	}

	var filterSetting = targetElement.closest('.filter-setting');
	if (!filterSetting) filterSetting = targetElement.closest('.filter-ib');
	if (targetElement.classList.contains('close-input')) filterSetting = targetElement;
	showFilterCollumn(filterSetting);
	if (filterSetting) {
		filterSetting.closest('th, .th').classList.add('filter-typing');
		return;
		//var filterBox = filterSetting.closest('th, .th').querySelector('.filter-box');
		//if (!filterBox) {

		//}
		//const rect = filterBox.getBoundingClientRect();
		//if (rect.left < 0) {
		//	filterBox.classList.add('direct-right');
		//}
		//addFilterTemplate(filterSetting);
		//var inputTag = filterSetting.closest('th, .th').querySelector('input');
		//if (inputTag) {
		//	inputTag.focus();
		//	inputTag.dispatchEvent(new Event('input', { bubbles: true }));
		//}
	}
	var editorElement = targetElement.closest('.text_editor');
	if (editorElement) {
		if (targetElement.tagName === 'LI') {
			var selectedText = targetElement.innerText;
			editorElement.innerHTML = selectedText;
			editorElement.setAttribute('class', editorElement.getAttribute('data-class'));
			var rowTag = editorElement.closest('[data-row-id]');
			if (rowTag) {
				var buttonSaveRow = rowTag.querySelector('.save_row');
				if (buttonSaveRow) {
					buttonSaveRow.setAttribute('data-post-name', editorElement.getAttribute('data-name'));
					buttonSaveRow.setAttribute('data-post-value', selectedText);
					buttonSaveRow.click();
				}
			}
		}
	}
});
document.body.addEventListener('focusout', function (e) {
	if (e.target.tagName.toLowerCase() === 'textarea') {
		var inputTag = e.target;
		var thTag = inputTag.closest('th, .th');
		if (!thTag) return;
		updateAreaSelected(inputTag);

		console.log('Input mất focus với giá trị:', e.target.value);
	}

	if (e.target.tagName.toLowerCase() === 'input') {
		var thTag = e.target.closest('.text_editor');
		if (thTag) {
			//debugger;
			//saveDataInput();
		}
	}
});
document.body.addEventListener('keydown', function (e) {

	if (e.key === "Escape") {
		closeFilterTyping();
		var inputTag = document.querySelector('.text_editor input');
		if (inputTag) {
			inputTag.value = inputTag.defaultValue;
			var parentElement = inputTag.parentElement;
			parentElement.innerText = inputTag.defaultValue;
			parentElement.setAttribute('class', parentElement.getAttribute('data-class'));
		}
	}

	if (e.target.tagName.toLowerCase() === 'input') {
		var inputTag = e.target;
		var thTag = inputTag.closest('th, .th');
		if (!thTag) return;

		if (e.key === 'Enter') {
			var liSelected = thTag.querySelector('ul li');
			if (liSelected) {
				updateLiSelected(liSelected);
				inputTag.value = '';
				inputTag.dispatchEvent(new Event('input', { bubbles: true }));
			}
		}
		if (e.key === 'Tab') {
			closeFilterTyping();
		}

	}
});
document.body.addEventListener('input', function (e) {
	if (e.target.readOnly) {
		return;
	}
	if (e.target.tagName.toLowerCase() === 'input') {
		var thTag = e.target.closest('th, .th');
		if (thTag) {
			if (!thTag.classList.contains('filter-typing')) thTag.classList.add('filter-typing');
			thTag.querySelectorAll('.error-msg').forEach((el) => { el.remove() });
			var filterIb = thTag.querySelector('.filter-ib');
			if (!filterIb) return;
			var dataSourceUrl = filterIb.getAttribute('data-source-url');
			var dataSourceKey = filterIb.getAttribute('data-source-key');

			if (dataSourceUrl) {
				var dataFilter = filterIb.getAttribute('data-filter');
				debouncedSearchPopupUrl(dataSourceUrl, dataSourceKey);
				return;
			}
			searchPopup(dataSourceKey);
		}

		var editorTag = e.target.closest('.text_editor');
		if (editorTag) {
			var dataSourceUrl = editorTag.getAttribute('data-source-url');
			var dataSourceKey = editorTag.getAttribute('data-source-key');

			if (dataSourceUrl) {
				debouncedSearchPopupUrl(dataSourceUrl, dataSourceKey);
				return;
			}
			searchPopup(dataSourceKey);
		}
	}
});

function debounce(func, delay) {
	let timeout;
	return function (...args) {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(function () {
			func.apply(context, args);
		}, delay);
	};
}
const debouncedSearchPopupUrl = debounce(searchPopupUrl, 200);
function showFilterCollumn(el) {
	if (!el) return;
	var thTag = el.closest('th, .th');
	thTag.classList.add('filter-typing');

	var thText = thTag.innerText.trim();
	var dataText = thTag.getAttribute('data-text');
	if (!dataText) thTag.setAttribute('data-text', thText);

	var filterBox = thTag.querySelector('.filter-box');
	if (!filterBox) {
		thTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
		filterBox = thTag.querySelector('.filter-box');
	}
	var dataMin = el.getAttribute('data-min');
	if (dataMin) {
		filterBox.style.minWidth = dataMin;
	}
	const rect = filterBox.getBoundingClientRect();
	if (rect.left < 0) {
		filterBox.classList.add('direct-right');
	}
	addFilterTemplate(el);
	var inputTag = thTag.querySelector('input');
	if (inputTag) {
		if (thTag.classList.contains('filter-editor')) {
			inputTag.setAttribute('data-old', inputTag.value);
		}
		var defaultText = el.getAttribute('data-default');
		if (defaultText) inputTag.value = defaultText;
		inputTag.focus();
		inputTag.dispatchEvent(new Event('input', { bubbles: true }));
	}

}
function showMenuExpress() {
	var menuTag = document.querySelector('.express-menu-displaying');
	if (menuTag) {
		menuTag.remove();
	}
	var focusRow = document.querySelector('.row-focused');
	if (focusRow) {
		focusRow.classList.remove('row-focused');
	}
}
function clearCurrentFilter(el) {
	var dataFor = el.getAttribute('data-for');
	if (dataFor) el = document.querySelector('[data-filter="' + dataFor + '"]');

	var sameFilters = document.querySelectorAll('[data-filter="' + dataFor + '"]');
	sameFilters.forEach((item, index) => {
		var parentTag = item.parentElement;
		var selectedTag = parentTag.querySelector('.item_selected');
		if (selectedTag) {
			selectedTag.innerHTML = '';
			var listSelectedLi = parentTag.querySelectorAll('.fa-checked');
			for (var i = 0; i < listSelectedLi.length; i++) {
				listSelectedLi[i].classList.remove('fa-checked');
			}
		}
		var thCheckTag = item.closest('th, .th');
		var checkboxItemTag = thCheckTag.querySelector('[type="checkbox"]');
		if (checkboxItemTag) {
			checkboxItemTag.checked = false;
		}
	});

	updateItemSearch(el);

	clearFilterRefer(el);
	showFilterDescriptions();

	searchForm(el);
}
function clearFilterRefer(el) {
	var parentTag = el.parentElement;
	var filterIb = parentTag.querySelector('.filter-ib');
	if (!filterIb) return;

	var filterKey = filterIb.getAttribute('data-filter');
	var sameFilters = document.querySelectorAll('[data-filter="' + filterKey + '"]');

	var referTag = document.querySelector('[data-filter-ref="' + filterKey + '"]');
	if (referTag) {
		var allButtons = referTag.querySelectorAll('button');
		for (var i = 0; i < allButtons.length; i++) {
			allButtons[i].classList.remove('active');
		}
	}

	sameFilters.forEach((item, index) => {
		var thTag = item.closest('th, .th');
		var selectedTag = thTag.querySelector('.item_selected');
		if (selectedTag) selectedTag.innerHTML = '';

		var select3Tag = item.closest('.select3');
		if (select3Tag) {
			var select3Items = select3Tag.querySelectorAll('.select3-item');
			select3Items.forEach(item => item.remove());
		}
	});

	updateItemSearch(el);
}
function clearAllFilter(el) {
	var selectedTags = document.querySelectorAll('.item_selected');
	for (var k = 0; k < selectedTags.length; k++) {
		var selectedTag = selectedTags[k];
		selectedTag.innerHTML = '';
		updateItemSearch(selectedTag);
		var parentTag = selectedTag.parentElement;
		var listSelectedLi = parentTag.querySelectorAll('.fa-checked');
		for (var i = 0; i < listSelectedLi.length; i++) {
			listSelectedLi[i].classList.remove('fa-checked');
		}
		clearFilterRefer(selectedTag);
	}
	showFilterDescriptions();
	searchForm(selectedTags[0]);
}
function changeFilterCheck(el) {
	var thTag = el.closest('th, .th');
	var checkTag = thTag.querySelector('[type="checkbox"]');
	var checked = checkTag.checked;
	var selectedTag = thTag.querySelector('.item_selected');
	if (!selectedTag) {
		thTag.insertAdjacentHTML('afterbegin', '<span class="item_selected"></span>');
		selectedTag = thTag.querySelector('.item_selected');
	}
	selectedTag.innerText = '';
	if (checked) {
		var labelTag = thTag.querySelector('label');
		selectedTag.innerText = labelTag.innerText;
	}
	updateFilerByElement(el);
	updateItemSearch(selectedTag);
	showFilterDescriptions();
}
function addFilterTemplate(processingElement) {
	var bindingId = processingElement.getAttribute('data-for');
	if (bindingId) {
		//processingElement.querySelector('input').setAttribute('oninput','searchPopup()');
		processingElement.innerHTML = processingElement.innerHTML + filterTemplate;
	}
}

function searchPopup(sourceName) {
	const focusedElement = document.activeElement;
	if (focusedElement.nodeName !== 'INPUT') return;
	var parentElement = focusedElement.parentElement;
	if (!sourceName) sourceName = parentElement.getAttribute('data-for');
	var source = [];
	var sourceTag = document.querySelector('#' + sourceName);
	if (sourceTag && sourceTag.value) source = sourceTag.value.split(',');
	var keyword = focusedElement.value.trim().toLowerCase();

	var filtered = source.filter(x => x.toLowerCase().includes(keyword));
	var selectedList = [];
	var filterElement = document.querySelector('.filter-typing .item_selected');
	if (filterElement) {
		selectedList = filterElement.innerText.replaceAll("; ", ";").split(';');
	}
	var thTag = focusedElement.closest('th, .th, .text_editor');
	if (thTag.classList.contains('filter-editor')) {
		selectedList = [focusedElement.value];
	}

	var ul = thTag.querySelector('ul');
	if (!ul) {
		thTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
		ul = thTag.querySelector('ul');
	}
	ul.innerHTML = '';
	var filterEditorTag = focusedElement.closest('.filter-editor, .text_editor');
	if (filterEditorTag) {
		var oldText = focusedElement.getAttribute('data-old');
		var text = focusedElement.value;
		if (text === oldText) filtered = source;
		focusedElement.setAttribute('data-old', text);
	}
	for (var i = 0; i < filtered.length; i++) {
		var li = document.createElement("LI");
		li.innerText = filtered[i];
		if (selectedList.includes(li.innerText) || li.innerText === focusedElement.value) {
			li.classList.add('fa-checked');
		} else {
			li.classList.remove('fa-checked');
		}
		ul.appendChild(li);
		if (i === 30) return;
	}
}
function searchPopupUrl(apiUrl, filedName) {
	var inputTag = document.activeElement;
	var thTag = inputTag.closest('th, .th');
	if (inputTag.nodeName !== 'INPUT') return;


	var keyword = inputTag.value.trim().toLowerCase();
	var keyword2 = inputTag.value.trim().toLowerCase().replace(/\s+/g, '');

	var filterEditorTag = inputTag.closest('.filter-editor');
	var dataRefer = '';
	if (filterEditorTag) {
		var oldText = inputTag.getAttribute('data-old');
		var text = inputTag.value;
		if (text === oldText) keyword = "";
		inputTag.setAttribute('data-old', text);
		dataRefer = inputTag.getAttribute('data-refer');
	}


	const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
	var requestUrl = `${apiUrl}?keyword=${encodeURIComponent(keyword)}`;
	if (dataRefer) requestUrl = `${requestUrl}&refer=${encodeURIComponent(dataRefer)}`;
	fetch(requestUrl, { method: 'GET', headers: headers })
		.then(function (response) {
			if (!response.ok) {
				throw new Error('HTTP error! Status: ' + response.status);
			}
			return response.json();
		})
		.then(function (data) {

			if (!filedName) filedName = 'name';
			const filtered = data.map(function (item) {
				if (typeof item === 'string') return item;
				return item[filedName];
			});

			var selectedList = [];
			var selectedTag = thTag.querySelector('.filter-typing .item_selected');
			if (selectedTag) {
				selectedList = selectedTag.innerText.replaceAll("; ", ";").split(';');
			}
			var selectedList2 = [];

			if (thTag.classList.contains('filter-editor')) {
				selectedList = [inputTag.value];
				selectedList2 = [keyword2];
			}
			var ul = thTag.querySelector('ul');
			if (!ul) {
				thTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
				ul = thTag.querySelector('ul');
			}
			ul.innerHTML = '';
			//for (var i = 0; i < filtered.length; i++) {
			//	var li = document.createElement("LI");
			//	li.innerText = filtered[i];
			//	var keyText = li.innerText.trim().toLowerCase().replace(/\s+/g, '');
			//	if (selectedList.includes(li.innerText) || selectedList2.includes(keyText)) {
			//		li.classList.add('fa-checked');
			//	}
			//	ul.appendChild(li);
			//	if (i === 30) return;
			//}

			window.sourceSearching = data;
			for (var i = 0; i < data.length; i++) {
				var item = data[i];
				var itemText = item[filedName];
				if (typeof item === 'string') itemText = item;

				var li = document.createElement("LI");
				if (item.level) li.setAttribute('data-filter-level', item.level);
				li.innerText = itemText;
				var keyText = li.innerText.trim().toLowerCase().replace(/\s+/g, '');
				if (selectedList.includes(li.innerText) || selectedList2.includes(keyText)) {
					li.classList.add('fa-checked');
				}
				ul.appendChild(li);
				if (i === 30) return;
			}


		})
		.catch(function (error) {
			console.error('Error API:', error);
		});
}
function updateAreaSelected(el) {
	var val = el.value;
	var thTag = el.closest('th, .th');
	var selectedTag = thTag.querySelector('.item_selected');
	if (!selectedTag) {
		thTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
		selectedTag = thTag.querySelector('.item_selected');
	}
	var selectedList = val.split(/[\n\r;]+/);
	selectedTag.innerText = selectedList.join('; ');
	updateFilerByElement(el);
	updateItemSearch(selectedTag);
	showFilterDescriptions();
}
function updateLiSelected(el) {
	var filterEditor = el.closest('.filter-editor');
	if (filterEditor) {
		filterEditor.querySelectorAll('ul li').forEach((item, index) => {
			item.classList.remove('fa-checked');
		});
		el.classList.add('fa-checked');
		var selectedText = el.innerText.replace(/\n+/g, ' ');

		var selectedTag = filterEditor.querySelector('.item_selected');
		if (selectedTag) selectedTag.innerHTML = selectedText;

		var filterIb = filterEditor.querySelector('.filter-ib');
		var dataSourceText = filterIb.getAttribute('data-source-text');
		var dataSourcekey = filterIb.getAttribute('data-source-key');

		var inputTag = filterEditor.querySelector('.filter-ib input');
		if (selectedText && window.sourceSearching && dataSourceText) {
			const itemSelected = window.sourceSearching.find(c => c[dataSourcekey] === selectedText);
			if (itemSelected) {
				inputTag.setAttribute('data-text', itemSelected[dataSourceText]);
			}
		}
		setInputValue(inputTag, selectedText);

		filterEditor.classList.remove('filter-typing');
		filterEditor.querySelectorAll('.item_selected').forEach((item => { item.innerText = inputTag.value; }))
		return;
	}

	if (el.classList.contains('fa-checked')) {
		el.classList.remove('fa-checked');
	} else {
		el.classList.add('fa-checked');
	}

	var val = el.innerText;

	var thTag = el.closest('th, .th');
	var selectedTag = thTag.querySelector('.item_selected');
	var selectedList = selectedTag.innerText.replaceAll("; ", ";").split(';');
	removeArray(selectedList, '');
	if (selectedList.includes(val)) {
		removeArray(selectedList, val);
	} else {
		selectedList.push(val);
	}
	selectedTag.innerText = selectedList.join('; ');
	updateFilerByElement(el);
	updateItemSearch(selectedTag);
	showFilterDescriptions();
}
function updateFilerByElement(el) {
	var thTag = el.closest('th, .th');
	var filterIb = thTag.querySelector('.filter-ib');
	if (!filterIb) return;
	var filterKey = filterIb.getAttribute('data-filter');

	var selectedTag = thTag.querySelector('.item_selected');
	var selectedText = selectedTag.innerText;
	var checkboxTag = thTag.querySelector('[type="checkbox"]');

	var sameFilterIbs = document.querySelectorAll('[data-filter="' + filterKey + '"]');
	sameFilterIbs.forEach((filterIb, index) => {
		var thCheckTag = filterIb.closest('th, .th');
		if (thCheckTag) {
			var selectedCheckTag = thCheckTag.querySelector('.item_selected');
			if (!selectedCheckTag) {
				thCheckTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
				selectedCheckTag = thCheckTag.querySelector('.item_selected');
			}
			selectedCheckTag.innerHTML = selectedText;

			//1.List active buttons

			//2.Select3
			showSelectedLi(el);
			var checkboxItemTag = thCheckTag.querySelector('[type="checkbox"]');
			if (checkboxTag && checkboxItemTag) {
				checkboxItemTag.checked = checkboxTag.checked;
			}

			//3.Update text area
			//var textareaTag = thCheckTag.querySelector('textarea');
			//if (textareaTag) {
			//	textareaTag.value = selectedText.replaceAll('; ', ';').replaceAll(';', '\n');
			//}
		}
	});

}
function updateItemSearch(el) {
	var thTag = el.closest('.filter-typing');
	if (!thTag) thTag = el.closest('th, .th');
	if (!thTag) return;
	var filterIb = thTag.querySelector('.filter-ib');
	if (!filterIb) return;
	var dataFilter = filterIb.getAttribute('data-filter');
	if (dataFilter) {
		var formId = filterIb.getAttribute('data-form');
		var form = document.querySelector('#' + formId);
		if (!form) form = thTag.closest('form');
		if (!form) form = thTag.querySelector('form');
		if (form) {
			var hidden = form.querySelector('[name="' + dataFilter + '"]');
			if (!hidden) {
				hidden = document.createElement('input');
				hidden.setAttribute('name', dataFilter);
				hidden.setAttribute('type', 'hidden');
				form.appendChild(hidden);
			}
			var selectedTag = thTag.querySelector('.item_selected');
			hidden.value = selectedTag.innerText.replaceAll('; ', ';');
		}
	}
}

function initializeFilterValue(oldData, newData) {
	if (newData === undefined) newData = {};
	const keys = Object.keys(oldData);
	for (let key of keys) {
		if (oldData[key] !== newData[key]) {
			var filterKey = key;
			var selectedText = oldData[key];

			var filterIbs = document.querySelectorAll('[data-filter="' + filterKey + '"]');
			filterIbs.forEach((filterIb, index) => {
				var thTag = filterIb.closest('th, .th');
				if (thTag) {
					var checkboxTag = thTag.querySelector('[type="checkbox"]');
					if (checkboxTag) checkboxTag.checked = Boolean(selectedText);

					var selectedTag = thTag.querySelector('.item_selected');
					if (!selectedTag) {
						thTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
						selectedTag = thTag.querySelector('.item_selected');
					}
					selectedTag.innerHTML = selectedText;
					var textareaTag = thTag.querySelector('textarea');

					if (textareaTag) {
						textareaTag.value = selectedText.replaceAll('; ', ';').replaceAll(';', '\n');
					}

					updateItemSearch(selectedTag);
				}
			});
		}
	}
	// clear all select3
	var select3Tags = document.querySelectorAll('.select3');
	select3Tags.forEach((thItemTag, index) => {
		var selectedItemTag = thItemTag.querySelector('.item_selected');
		if (!selectedItemTag || !selectedItemTag.innerText) {
			var select3Items = thItemTag.querySelectorAll('.select3-item');
			select3Items.forEach(item => item.remove());
		}
	});

	// clear text area
	var flterAreaTags = document.querySelectorAll('.filter-area');
	flterAreaTags.forEach((thItemTag, index) => {
		var selectedItemTag = thItemTag.querySelector('.item_selected');
		if (!selectedItemTag || !selectedItemTag.innerText) {
			var areaTags = thItemTag.querySelectorAll('textarea');
			areaTags.forEach(item => item.value = '');
		}
	});
	showFilterDescriptions();
}
window.initializeFilterValue = initializeFilterValue;
function addFilterValue(filterKey, value) {
	var filterIb = document.querySelector('[data-filter="' + filterKey + '"]');
	if (!filterIb) return;
	var thTag = filterIb.closest('th, .th');
	var selectedTag = thTag.querySelector('.item_selected');
	if (!selectedTag) {
		thTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
		selectedTag = thTag.querySelector('.item_selected');
	}
	selectedTag.innerHTML = value;
	updateItemSearch(selectedTag);
	showFilterDescriptions();
}
window.addFilterValue = addFilterValue;
function removeArray(arr, item) {
	const index = arr.indexOf(item);
	if (index > -1) {
		arr.splice(index, 1);
	}
}
function showFilterDescriptions() {
	var filterDesTag = document.querySelector('.filter-des');
	if (!filterDesTag) filterDesTag = document.createElement('span');
	filterDesTag.innerHTML = '';
	const selectedItems = document.querySelectorAll('.item_selected:not(:empty)');
	var allReferButtons = document.querySelectorAll('[data-filter-ref] button');
	for (var i = 0; i < allReferButtons.length; i++) allReferButtons[i].classList.remove('active');
	for (var i = 0; i < selectedItems.length; i++) {
		var item = selectedItems[i];
		var thTag = item.closest('th, .th');
		var thText = thTag.innerText;
		thText = thText.trim().split('\n')[0];
		var filterIb = thTag.querySelector('[data-filter]');
		if (!filterIb) continue;
		var dataFor = filterIb.getAttribute('data-filter');
		if (!thTag.classList.contains('th') || thTag.classList.contains('display')) {
			var itemDes = filterDesTag.querySelector('[data-text="' + thText + '"] .fil-text');
			if (!itemDes) {
				var itemDesHtml = '<span class="filter-des-item" data-text="' + thText + '"><span class="fil-text"></span><i class="close-i close-i3" data-for="' + dataFor + '"></i></span>';
				filterDesTag.insertAdjacentHTML('beforeend', itemDesHtml);
				itemDes = filterDesTag.querySelector('[data-text="' + thText + '"] .fil-text');
			}
			itemDes.innerHTML = item.innerHTML;
		}

		//add active for buttons references
		var referTag = document.querySelector('[data-filter-ref="' + dataFor + '"]');
		if (referTag) {
			var allButtons = referTag.querySelectorAll('button');
			var listText = item.innerText.replaceAll('; ', ';');
			var listValues = listText.split(';');
			for (var k = 0; k < allButtons.length; k++) {
				const buttonText = Array.from(allButtons[k].childNodes).filter(node => node.nodeType === 3).map(node => node.textContent.trim()).join('');
				if (!buttonText) continue;
				if (listValues.includes(buttonText)) allButtons[k].classList.add('active');
			}
		}

		// for select3
		showSelectedLi(item);

	}
	var desList = filterDesTag.querySelectorAll('.filter-des-item');
	if (desList.length > 1) {
		filterDesTag.insertAdjacentHTML('afterbegin', '<span class="close-i close-i2"></span>');
	}
}

function showSelectedLi(el) {
	var select3Tag = el.closest('.select3');
	if (select3Tag) {
		var select3Items = select3Tag.querySelectorAll('.select3-item');
		select3Items.forEach(item => item.remove());

		var selectedTag = select3Tag.querySelector('.item_selected');
		var listText = selectedTag.innerText.replaceAll('; ', ';');
		var listValues = listText.split(';');
		for (var k = listValues.length - 1; k >= 0; k--) {
			if (!listValues[k]) continue;
			select3Tag.insertAdjacentHTML('afterbegin', '<span class="select3-item">' + listValues[k] + '</span>');
		}
		var thTag = el.closest('th, .th');
		var filterIb = thTag.querySelector('.filter-ib');
		var dataFilter = filterIb.getAttribute('data-filter');
		var sameFilters = document.querySelectorAll('[data-filter="' + dataFilter + '"]');
		for (var i = 0; i < sameFilters.length; i++) {
			var thCheckTag = sameFilters[i].closest('th, .th');
			var selectedCheckTag = thCheckTag.querySelector('.item_selected');
			if (!selectedCheckTag) {
				thCheckTag.insertAdjacentHTML("beforeend", filterCollumnTemplate);
				selectedCheckTag = thCheckTag.querySelector('.item_selected');
			}
			if (selectedCheckTag.innerText !== selectedTag.innerText) {
				selectedCheckTag.innerText = selectedTag.innerText;
			}
		}
	}
}
function closeFilterTyping() {
	var filterBox = document.querySelector('.filter-typing');
	if (filterBox) {
		filterBox.classList.remove('filter-typing');
		var filterTag = filterBox.querySelector('[data-filter]');
		if (filterTag) searchForm(filterBox);
	}
}
function searchForm(el) {
	var thTag = el.closest('th, .th-col');
	if (!thTag) return;

	var filterIb = thTag.querySelector('.filter-ib');
	var formSelector = 'form';
	var formId = filterIb.getAttribute('data-form');
	if (formId) formSelector = '#' + formId;
	var submitButton = document.querySelector(formSelector + ' [type="submit"]');
	if (!submitButton) submitButton = document.querySelector(formSelector + ' [type="button"]');
	if (submitButton) submitButton.click();
}

function saveDataInput() {

	var targetElement = document.activeElement;
	var editorTag = targetElement.closest('.text_editor');
	var ulActive = document.querySelector('.text_editor ul:has(li)');
	//if (ulActive) return;
	if (!ulActive) {
		var dataClass = targetElement.parentElement.getAttribute('data-class');
		if (dataClass) targetElement.parentElement.className = dataClass;
		targetElement.parentElement.innerText = targetElement.value;
		saveOrderModel(editorTag);
	}
}
addNewRow();
function addNewRow() {
	var tableEditor = document.querySelector('.table-editor');
	if (!tableEditor) return;
	var no = 0;
	var lastRow = document.querySelector('.table-editor tbody tr:last-child');

	if (lastRow) {
		var noTag = lastRow.querySelector('[data-name="No"]');
		if (!noTag) return;
		var no = noTag.innerText;
		var listCells = lastRow.querySelectorAll('td');
		var allText = '';
		for (var i = 0; i < listCells.length; i++) {
			allText += listCells[i].innerText;
		}
		if (allText.trim() === "") return;
		var rowId = lastRow.getAttribute("data-row-id");
		if (rowId === '0') return;
	}

	var template = document.querySelector('.template_row');
	if (!template) return;
	var tableRef = document.querySelector('.table-editor tbody');
	var newRow = tableRef.insertRow(tableRef.rows.length);
	newRow.innerHTML = template.innerHTML;
	newRow.setAttribute('data-row-id', '0');

	var nextNo = parseInt(no) + 1;
	newRow.querySelector('[data-name="No"]').innerText = nextNo;
}

function saveOrderModel(editorTag) {
	if (!editorTag) return;
	var dataForm = {};
	dataForm.Field = editorTag.getAttribute('data-name');

	var rowTag = editorTag.closest('[data-row-id]');
	dataForm.Id = rowTag.getAttribute('data-row-id');

	return;
	dataForm.OrderCode = rowTag.querySelector('[data-name="OrderCode"]').innerText;
	dataForm.ShippingCode = rowTag.querySelector('[data-name="ShippingCode"]').innerText;
	dataForm.ProductCode = rowTag.querySelector('[data-name="ProductCode"]').innerText;
	dataForm.ProductName = rowTag.querySelector('[data-name="ProductName"]').innerText;

	dataForm.CustomerName = rowTag.querySelector('[data-name="CustomerName"]').innerText;
	dataForm.Price0 = rowTag.querySelector('[data-name="Price0"]').innerText;
	dataForm.OrderFee = rowTag.querySelector('[data-name="OrderFee"]').innerText;

	dataForm.SalePrice = rowTag.querySelector('[data-name="SalePrice"]').innerText;
	dataForm.Size = rowTag.querySelector('[data-name="Size"]').innerText;

	dataForm.Color = rowTag.querySelector('[data-name="Color"]').innerText;
	dataForm.Quantity = rowTag.querySelector('[data-name="Quantity"]').innerText;
	dataForm.ArriveQuantity = rowTag.querySelector('[data-name="ArriveQuantity"]').innerText;
	dataForm.Money = rowTag.querySelector('[data-name="Money"]').innerText;

	dataForm.OrderStatus = rowTag.querySelector('[data-name="OrderStatus"]').innerText;
	dataForm.Notes = rowTag.querySelector('[data-name="Notes"]').innerText;


	fetch('/orders/SaveOrderModel', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: new URLSearchParams(dataForm)
	})
		.then(response => response.json())
		.then(resultData => {
			rowTag.setAttribute('data-row-id', resultData.id);
			rowTag.setAttribute('data-customer-id', resultData.customerId);
			rowTag.querySelector('[data-name="ProductCode"]').innerText = resultData.productCode;
			rowTag.querySelector('[data-name="ProductName"]').innerText = resultData.productName;

			rowTag.querySelector('[data-name="Price0"]').innerText = resultData.price0;
			rowTag.querySelector('[data-name="SalePrice"]').innerText = resultData.salePrice;

			rowTag.querySelector('[data-name="Money"]').innerText = resultData.money;
			rowTag.querySelector('[data-name="OrderFee"]').innerText = resultData.orderFee;

			rowTag.querySelector('[data-name="Contracted"]').innerText = resultData.contractedDateText;
			rowTag.querySelector('[data-name="OrderDate"]').innerText = resultData.orderDateText;
			rowTag.querySelector('[data-name="ArriveDate"]').innerText = resultData.arriveDateText;
			rowTag.querySelector('[data-name="OrderStatus"]').innerText = resultData.status;
			addNewRow();
		})
		.catch(error => {
			console.error('Error:', error);
		});
}


function nextStatus(editorTag) {
	if (!editorTag) return;
	var rowFocused = document.querySelector('.row-focused');
	if (!rowFocused) return;

	var listStatusTag = document.querySelector('#ListTextOrderStatus');
	if (!listStatusTag) return;
	var listStatus = listStatusTag.value.split(',');
	var statusTag = rowFocused.querySelector('[data-name="OrderStatus"]');
	var currentStatus = statusTag.innerText;
	var index = listStatus.indexOf(currentStatus);
	var doneIndex = listStatus.indexOf('Done');
	if (index >= doneIndex) return;
	var nextValue = listStatus[index + 1];
	statusTag.innerHTML = nextValue;
	saveOrderModel(statusTag);
}
function changeRowChecked(targetElement) {
	var row = targetElement.closest('[data-row-id]');
	if (!row) return;
	if (row.classList.contains('row_checked')) {
		row.classList.remove('row_checked');
	} else {
		row.className = "row_checked";
	}
	var customerIds = [];
	var listCheckedRows = document.querySelectorAll('.row_checked');
	for (var i = 0; i < listCheckedRows.length; i++) {
		var customerId = listCheckedRows[i].getAttribute('data-customer-id');
		if (customerIds.includes(customerId)) continue;
		customerIds.push(customerId);
	}
	document.querySelector('.create_invoice').classList.add('disabled');
	if (customerIds.length === 1) {
		document.querySelector('.create_invoice').classList.remove('disabled');
	}
}


function setInputValue(inputTag, text) {

	const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
		window.HTMLInputElement.prototype,
		"value"
	).set;

	nativeInputValueSetter.call(inputTag, text);

	const event = new Event("input", { bubbles: true });
	inputTag.dispatchEvent(event);
}